import React, { useCallback } from 'react';
import { Editor, Element } from 'slate';
import { ReactEditor, useSlateStatic } from 'slate-react';
import { insertAndUpload } from '../../lib/insertAndUpload';
import { AulaEditorContext } from '../../types';
import { HiddenFileInput } from './FileUploadInput.styled';

type Props = {
  element: Element;
  context: Omit<AulaEditorContext, 'entities'>;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const FileUploadInput = React.forwardRef<HTMLInputElement, Props>(
  ({ element, context, onChange }, ref) => {
    const editor = useSlateStatic();
    const at = ReactEditor.findPath(editor, element);
    const end = Editor.edges(editor, at)[1];

    const uploadFiles = useCallback(
      (event) => {
        const range = {
          anchor: end,
          focus: end,
        };

        for (const _file of event.target.files) {
          insertAndUpload({
            file: _file,
            range,
            editor,
            context,
          });
        }
      },
      [context, editor, end]
    );

    return (
      <HiddenFileInput
        data-testid="block-menu-file-input"
        aria-hidden="true"
        type="file"
        multiple
        ref={ref}
        onClick={(e) => {
          e.stopPropagation();
        }}
        onChange={(event) => {
          onChange?.(event);
          uploadFiles(event);
        }}
      />
    );
  }
);
